import { IronRV } from "../utils/ironsource";

export function rewardVideoAdBlocked(state, action) {

  console.log("Reward Video Ad Blocked", action);
  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};
  nextState.rewardVideo.adBlocked = (action && action.data) || false;

  return nextState;
}

export function rewardVideoReady(state, action) {

  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};

  if (action.data === null) {
    nextState.rewardVideo.ready = null;
  } else if (action.data.name === IronRV.EVENTS.READY) {
    nextState.rewardVideo.ready = true;
  } else {
    nextState.rewardVideo.ready = false;
  }

  console.log("Reward Video Ready", action, nextState);
  
  return nextState;
}

export function setIronRV(state, action) {

  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};

  if (action) {
    nextState.rewardVideo.ironRV = action.data;
  }

  console.log("Reward Video setIronRV", action, nextState);

  return nextState;
}

export function rewardVideoOpen(state, action) {

  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};

  if (action.data.name === IronRV.EVENTS.OPEN) {
    nextState.rewardVideo.open = true;
    nextState.rewardVideo.complete = false;
  } else {
    nextState.rewardVideo.open = false;
  }

  console.log("Reward Video Open", action, nextState);
  
  return nextState;
}

export function rewardVideoComplete(state, action) {
  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};
  nextState.rewardVideo.complete = true;
  
  console.log("Reward Video Complete", action, nextState);
  return nextState;
}

export function setRewardVideoSupport(state, action) {
  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};
  nextState.rewardVideo.support = window.screen && (window.screen.availWidth > 706);

  console.log("Reward Video Supported", action, nextState);
  return nextState;
}

export function updateRewardVideoStale(state, action) {
  const nextState = {...state};
  nextState.rewardVideo = {...state.rewardVideo};
  nextState.rewardVideo.stale = action.data;

  console.log("Reward Video Supported", action, nextState);
  return nextState;
}


// WEBPACK FOOTER //
// ./src/js/reducers/rewardVideo.js